"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Columns = _ref => {
  let {
    isMobile,
    isDesktop,
    isGapless,
    isMultiline,
    isVCentered,
    isCentered,
    gapSize,
    gapSizeMobile,
    gapSizeTablet,
    gapSizeDesktop,
    gapSizeWidescreen,
    gapSizeFullhd,
    className,
    renderAs,
    children,
    ...rest
  } = _ref;
  let display = isMobile ? 'mobile' : null;
  display = isDesktop ? 'desktop' : display;
  const classNames = (0, _classnames.default)({
    [`is-${display}`]: display,
    'is-gapless': isGapless,
    'is-multiline': isMultiline,
    'is-vcentered': isVCentered,
    'is-centered': isCentered,
    [`is-${gapSize}`]: gapSize,
    [`is-${gapSizeMobile}-mobile`]: gapSizeMobile,
    [`is-${gapSizeTablet}-tablet`]: gapSizeTablet,
    [`is-${gapSizeDesktop}-desktop`]: gapSizeDesktop,
    [`is-${gapSizeWidescreen}-widescreen`]: gapSizeWidescreen,
    [`is-${gapSizeFullhd}-fullhd`]: gapSizeFullhd,
    'is-variable': gapSize || gapSizeMobile || gapSizeTablet || gapSizeDesktop || gapSizeWidescreen || gapSizeFullhd
  });
  const coreClassNames = (0, _CoreProps.useClassNames)(rest);
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('columns', className, classNames, coreClassNames)
  }, children);
};
Columns.propTypes = {
  isMobile: _propTypes.default.bool,
  isDesktop: _propTypes.default.bool,
  isGapless: _propTypes.default.bool,
  isMultiline: _propTypes.default.bool,
  isVCentered: _propTypes.default.bool,
  isCentered: _propTypes.default.bool,
  gapSize: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8]),
  gapSizeMobile: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8]),
  gapSizeTablet: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8]),
  gapSizeDesktop: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8]),
  gapSizeWidescreen: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8]),
  gapSizeFullhd: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8]),
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
Columns.defaultProps = {
  renderAs: 'div'
};
var _default = exports.default = Columns;
//# sourceMappingURL=Columns.js.map